import { GlobalContext } from '../../../App'
import { metodoPrograma } from '../../../components/api'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from '@mui/material'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import Table from '../../../components/Table/Table'
import { IoReload } from 'react-icons/io5'
import { MdDelete } from 'react-icons/md'
import { Add } from '@mui/icons-material'
import { EdicaoServico } from './EdicaoServico'

const createTpAtendimento = z.object({
  idLocalAtendimento: z.number(),
  idTipoAgendamento: z.number().nullable().optional(),
  dsTipoAgendamento: z
    .string()
    .min(3, { message: 'Nome inválido' })
    .max(100, { message: 'Nome inválido' }),
})

export const Edicao = ({ dados, voltar }) => {
  const [listaServicos, setListaServicos] = useState([])
  const { localAtendimento } = useContext(GlobalContext)
  const [openModalServico, setOpenModalServico] = useState(false)
  const [dadosServico, setDadosServico] = useState([])
  const { register, handleSubmit, watch, setValue } = useForm({
    resolver: zodResolver(createTpAtendimento),
    defaultValues: {
      idLocalAtendimento: localAtendimento[0],
      idTipoAgendamento: dados?.[0] || null,
      dsTipoAgendamento: dados?.[2] || '',
    },
  })

  const salvar = async (values) => {
    metodoPrograma('salva', values).then((res) => {
      if (res.status) {
        setValue('idTipoAgendamento', res.idTipoAgendamento)
      }
    })
  }
  const getListaServicos = useCallback(() => {
    metodoPrograma('getServicosDoLocal', {
      idTipoAgendamento: watch('idTipoAgendamento'),
    }).then((res) => {
      if (res.status) {
        setListaServicos(res.lista)
      }
    })
  }, [watch])

  const exclui = (e, idServico) => {
    e.stopPropagation()
    metodoPrograma('removeServico', {
      idTipoAgendamento: watch('idTipoAgendamento'),
      cdServico: idServico,
    }).then((res) => {
      if (res.status) {
        getListaServicos()
      }
    })
  }

  const handleClick = (e, item) => {
    e.stopPropagation()
    setDadosServico(item)
    setOpenModalServico(true)
  }

  useEffect(() => {
    if (watch('idTipoAgendamento')) {
      getListaServicos()
    }
  }, [getListaServicos, watch])

  return (
    <form onSubmit={handleSubmit(salvar)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            {...register('dsTipoAgendamento')}
            label="Tipo Atendimento"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
        {watch('idTipoAgendamento') && (
          <Grid item xs={12}>
            <Table
              actions={[
                [
                  'Adiciona Serviço',
                  <Add key={0} />,
                  () => setOpenModalServico(true),
                ],
              ]}
              fixedToolbar
              disableFilter
              dados={listaServicos}
              head={['Serviço', '', '']}
              line={(item) => [item[1], item[2], '']}
              columnOptions={[
                {
                  alias: 2,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton
                      size="small"
                      onClick={(e) => exclui(e, linhaOriginal[0])}
                    >
                      {linhaOriginal[3] ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
              onClick={handleClick}
            />
          </Grid>
        )}
      </Grid>
      <Dialog
        open={openModalServico}
        onClose={() => {
          setDadosServico([])
          setOpenModalServico(false)
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Serviço</DialogTitle>
        <DialogContent>
          <EdicaoServico
            setOpenModalServico={setOpenModalServico}
            dados={dadosServico}
            getListaServicos={getListaServicos}
            idTipoAgendamento={watch('idTipoAgendamento')}
          />
        </DialogContent>
      </Dialog>
    </form>
  )
}
